document.addEventListener('DOMContentLoaded', () => {
    const mediaQuery = window.matchMedia('(width < 1200px)');
    const hamTrigger = document.getElementById('ham-trigger');
    const hamSvg = hamTrigger ? hamTrigger.querySelector('.ham') : null;

    if (!hamTrigger) return;

    function switchElementType(element, newTagName) {
        if (!element || element.tagName.toLowerCase() === newTagName.toLowerCase()) return element;
        const newElement = document.createElement(newTagName);
        for (const attr of element.attributes) {
            newElement.setAttribute(attr.name, attr.value);
        }
        while (element.firstChild) {
            newElement.appendChild(element.firstChild);
        }
        element.parentNode.replaceChild(newElement, element);
        return newElement;
    }

    let clickHandler = null;

    function closePopovers(wrapper) {
        wrapper.querySelectorAll('[popover]').forEach(popover => {
            if (typeof popover.hidePopover === 'function') popover.hidePopover();
        });
    }

    function handleBreakpointChange(e) {
        let wrapper = document.getElementById('header-wrapper');
        if (!wrapper) return;

        closePopovers(wrapper);

        if (e.matches) {
            // Mobile: Mutate element to a native <dialog>
            if (wrapper.tagName.toLowerCase() === 'div') {
                wrapper = switchElementType(wrapper, 'dialog');
            }
            wrapper.inert = !wrapper.open;
            hamTrigger.setAttribute('aria-expanded', String(wrapper.open));

            // Wipe out any leftover native invoker commands
            hamTrigger.removeAttribute('command');
            hamTrigger.removeAttribute('commandfor');

            // Set up manual non-modal trigger toggle logic
            if (clickHandler) hamTrigger.removeEventListener('click', clickHandler);

            clickHandler = () => {
                if (wrapper.hasAttribute('open')) {
                    closePopovers(wrapper);
                    wrapper.close();
                    wrapper.inert = true;
                    hamTrigger.setAttribute('aria-expanded', 'false');
                    hamTrigger.focus();
                    if (hamSvg) hamSvg.classList.remove('active');
                } else {
                    wrapper.inert = false;
                    wrapper.show(); // Non-modal: Background remains fully active!
                    hamTrigger.setAttribute('aria-expanded', 'true');
                    if (hamSvg) hamSvg.classList.add('active');
                }
            };

            hamTrigger.addEventListener('click', clickHandler);
        } else {
            // Desktop: Clean up listeners and revert to <div>
            if (clickHandler) {
                hamTrigger.removeEventListener('click', clickHandler);
                clickHandler = null;
            }

            if (wrapper.tagName.toLowerCase() === 'dialog') {
                if (wrapper.hasAttribute('open')) {
                    wrapper.close();
                }
                wrapper = switchElementType(wrapper, 'div');
                wrapper.removeAttribute('open');
            }
            wrapper.inert = false;
            hamTrigger.setAttribute('aria-expanded', 'false');
            if (hamSvg) hamSvg.classList.remove('active');
        }
    }

    handleBreakpointChange(mediaQuery);
    mediaQuery.addEventListener('change', handleBreakpointChange);
});